// Redux Toolkit store configuration
// This file provides backward compatibility - the actual store is now configured with RTK
import { createStore } from './index';

export default createStore;
